import React from "react";
import { StyledTextArea } from "./styled";

interface TextAreaProps {
  type?: string;
  name: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  placeholder: string;
  error?: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  minLength?: number;
  maxLength?: number;
  rows?: number;
}

const TextArea: React.FC<TextAreaProps> = ({
  type = "text",
  name,
  value,
  onChange,
  onFocus,
  onBlur,
  placeholder,
  error,
  label,
  required = false,
  disabled = false,
  autoFocus = false,
  minLength = 1000000000000000,
  maxLength = 1000000000000000,
  rows = 5,
  ...props
}) => {
  return (
    <StyledTextArea error={error || ""}>
      <label htmlFor={name}>{label}</label>
      <textarea
        rows={rows}
        name={name}
        value={value}
        onChange={(e) => onChange && onChange(e)}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        autoFocus={autoFocus}
        minLength={minLength}
        maxLength={maxLength}
        {...props}
      />
      {error && <small>{error}</small>}
    </StyledTextArea>
  );
};

export default TextArea;
